<template>
  <div class="account tab-wrap">
    <div class="insertBox">
    <div class="tab-containers">
      <ul class="tab-list">
        <li v-for="tab in tabs" :key="tab.id" :class="{active: activeTab === tab.id}" class="tab tabindex" @click="activeTab=tab.id">
          {{tab.label}}
        </li>
      </ul>
      <ul class="status-container" v-if="activeTab==='device'">
        <li v-for="(value,key) in deviceStatus" :key="key" class="status">
          <span class="status-label">
            <i class="status-icon" :class="value.class"></i>
            {{value.label + ' : '}}
          </span>
          <span class="status-num">{{value.num}}</span>
        </li>
      </ul>
      <ul class="status-container" v-else>
        <li v-for="(value,key) in dataloggerStatus" :key="key" class="status">
          <span class="status-label">
            <i class="status-icon" :class="value.class"></i>
            {{value.label + ' : '}} 
          </span>
           <span class="status-num">{{value.num}}</span>
        </li>
      </ul>
    </div>
    <component :is="activeTab" class="tab-contents"></component>
    </div>
  </div>
</template>
<script>
import device from './device'
import datalogger from './datalogger'
export default {
  components: {
    device,
    datalogger
  },
  data() {
    return {
      activeTab: 'device',
      tabs: [
        {
        id: 'device',
        label: this.$t('device.deviceList')
      },
      {
        id: 'datalogger',
        label: this.$t('device.dataloggerList')
      }],
      deviceStatus: {
        normalCount: {
          num: 0,
          label: this.$t('statistic.normal'),
          class: 'status-normal'
        },
        offCount: {
          num: 0,
          label: this.$t('statistic.offline'),
          class: 'status-offline'
        },
        faultCount: {
          num: 0,
          label: this.$t('statistic.fault'),
          class: 'status-fault'
        },
        standby: {
          num: 0,
          label: this.$t('statistic.standby'),
          class: 'status-standby'
        },
        warningCount: {
          num: 0,
          label: this.$t('statistic.warning'),
          class: 'status-warning'
        }
      },
      dataloggerStatus: {
        onLineCount: {
          num: 0,
          label: this.$t('statistic.normal'),
          class: 'status-normal'
        },
        offLineCount: {
          num: 0,
          label: this.$t('statistic.offline'),
          class: 'status-offline'
        },
      }
    }
  },
  created() {
    this.queryDeviceStatus()
    this.queryDataloggerStatus()
  },
  methods: {
    // 查询设备状态
    queryDeviceStatus () {
      let param = {
        devtype: 2304
      }
      this.$request.get('webQueryDeviceStatusViewEs', param).then(res => {
        if(res.err === 0) {
          for (let key in this.deviceStatus) {
            this.deviceStatus[key].num = res.dat[key]
          }
        }
      })
    },
    // 查询数采器状态
    queryDataloggerStatus () {
      let param = {
        devtype: 2304
      }
      this.$request.get('queryCollectorCountEs', param).then(res => {
        if(res.err === 0) {
          for (let key in this.dataloggerStatus) {
            this.dataloggerStatus[key].num = res.dat[key]
          }
        }
      })
    }
  },
}
</script>
<style lang="less" scoped>
@import url('../../../../assets/css/mixin.less');
.insertBox{
  margin:10px;
  // margin: 24px 24px 50px 24px;
  display: flex;
  flex:1;
  background: #fff;
  border-radius: 4px;
  flex-direction: column;
  overflow:auto;
  }
.tab-containers {
  margin:0px;
  padding:0px;
  justify-content: space-between;
  align-items: center;
  // border-bottom: none;
  padding:0 15px;
  .tab.active{
      // border-bottom:none;
      color: @themeColor;
      // font-size: 16px;
    }
    .tab{
      .sc(14px, #808080);
      padding:17px 0;
    }
  .tab-list {
    display: flex;
    flex-direction: row;
  }
  .tabindex{
    font-weight: bold;
    margin-right: 30px;
  }
  .status-container {
    display: flex;
    align-items: center;
    .status {
      // padding: 5px 20px;
      border-radius: 25px;
      box-shadow: 0px -1px 2.5px #7F7F7F;;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 0 10px;
      padding: 0px 20px;
      height: 32px;
      line-height: 32px;
      background-color: #fff;
      // border: 1px solid #000;
      border-radius: 18px;
      box-shadow: inset 0px 0px 5px 1px #ccc;
      &-num {
        color: #333;
        font-size: 14px;
      }
      &-label {
        color: #333;
        font-size: 14px;
      }
      &-icon {
        width: 10px;
        height: 10px;
        margin-right: 3px;
      }
    }
  }
}
</style>